import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  GET_MANY_REFERENCE,
  CREATE,
  UPDATE,
  UPDATE_MANY,
  DELETE,
  DELETE_MANY,
  fetchUtils
} from "react-admin";
import { stringify } from "query-string";
import { toast } from "react-toastify";

import { keepAccessTokenUpdated } from "./views/utilities/extraAPIs";
require("dotenv")

const environment = process.env.NODE_ENV || "development";
const primaryCompany = process.env.REACT_APP_PRIMARY_ORG;

export const PRIVATE_API_URL =
  environment == "development"
    ? `https://www.${primaryCompany}-proxyapp.ca/private`
    : `https://www.${primaryCompany}-proxyapp.ca/private`;

// export const PRIVATE_API_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000/private'

/**
 * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
 * @param {String} resource Name of the resource to fetch, e.g. 'posts'
 * @param {Object} params The Data Provider request params, depending on the type   ksjdhfklsj
 * @returns {Object} { url, options } The HTTP request parameters
 */
const convertDataProviderRequestToHTTP = async (type, resource, params) => {
  const shouldShowToast = false;
  await keepAccessTokenUpdated(shouldShowToast);
  let accessToken = localStorage.getItem("accessToken");
  const headers = new Headers({ Authorization: `Bearer ${accessToken}` });

  switch (type) {
    case GET_LIST: {
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;

      const query = {
        sort: JSON.stringify([field, order]),
        range: JSON.stringify([page, perPage]),
        filter: JSON.stringify(params.filter)
      };
      return {
        url: `${PRIVATE_API_URL}/${resource}?${stringify(query)}`,
        options: { headers, method: "GET" }
      };
    }
    case GET_ONE:
      return {
        url: `${PRIVATE_API_URL}/${resource}/${params.id}`,
        options: { headers, method: "GET" }
      };
    case GET_MANY: {
      const query = {
        filter: JSON.stringify(params.filter)
      };
      return {
        url: `${PRIVATE_API_URL}/${resource}?${stringify(query)}`,
        options: { headers, method: "GET" }
      };
    }
    case GET_MANY_REFERENCE: {
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;
      const query = {
        sort: JSON.stringify([field, order]),
        range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
        filter: JSON.stringify({ ...params.filter }),
        association: JSON.stringify({ [params.target]: params.id })
      };

      return {
        url: `${PRIVATE_API_URL}/${resource}?${stringify(query)}`,
        options: { headers, method: "GET" }
      };
    }
    case UPDATE:
      return {
        url: `${PRIVATE_API_URL}/${resource}/${params.id}`,
        options: { headers, method: "PUT", body: JSON.stringify(params.data) }
      };
    case UPDATE_MANY: {
      const query = {
        filter: JSON.stringify({ id: params.ids })
      };
      return {
        url: `${PRIVATE_API_URL}/${resource}?${stringify(query)}`,
        options: {
          headers,
          method: "PATCH",
          body: JSON.stringify(params.data)
        }
      };
    }
    case CREATE:
      return {
        url: `${PRIVATE_API_URL}/${resource}`,
        options: { headers, method: "POST", body: JSON.stringify(params.data) }
      };
    case DELETE:
      return {
        url: `${PRIVATE_API_URL}/${resource}/${params.id}`,
        options: { headers, method: "DELETE" }
      };
    case DELETE_MANY: {
      const query = {
        filter: JSON.stringify({ ids: params.ids })
      };
      return {
        url: `${PRIVATE_API_URL}/${resource}?${stringify(query)}`,
        options: { headers, method: "DELETE" }
      };
    }
    default:
      throw new Error(`Unsupported fetch action type ${type}`);
  }
};

/**
 * @param {Object} response HTTP response from fetch()
 * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
 * @param {String} resource Name of the resource to fetch, e.g. 'posts'
 * @param {Object} params The Data Provider request params, depending on the type
 * @returns {Object} Data Provider response
 */
const convertHTTPResponseToDataProvider = (
  response,
  type,
  resource,
  params
) => {
  const { headers, json } = response;

  response.status !== 200 && json.msg &&
    toast.error(json.msg, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      pauseOnHover: true,
      draggable: false
    });

  switch (type) {
    case GET_LIST:
      return {
        data: json.data,
        total: json.total
      };
    case CREATE:
      return { data: { ...json.data, id: json.id } };
    case UPDATE:
      return { data: json.data };
    case DELETE_MANY:
      return { data: [] };
    default:
      return json;
  }
};

/**
 * @param {string} type Request type, e.g GET_LIST
 * @param {string} resource Resource name, e.g. "posts"
 * @param {Object} payload Request parameters. Depends on the request type
 * @returns {Promise} the Promise for response
 */
export default async (type, resource, params) => {
  const { fetchJson } = fetchUtils;
  const { url, options } = await convertDataProviderRequestToHTTP(
    type,
    resource,
    params
  );

  return fetchJson(url, options).then(response => {
    return convertHTTPResponseToDataProvider(response, type, resource, params);
  });
};
